import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ChooseAgreement from 'components/ChooseAgreement/ChooseAgreement';
import ChooseDeposit from 'components/ChooseDeposit/ChooseDeposit';
import DividerComponent from 'components/Divider/Divider';
import useTransferTag from 'hooks/tags/useTransferTag';
import { TRANSFER_TAG_SUMMARY } from 'routes/overview/TransferTag/paths';
import ChooseTag from './ChooseTag/ChooseTag';
import ChooseVehicle from './ChooseVehicle/ChooseVehicle';
import TransferTagLayout from './TransferTagLayout';
export default function TransferTag() {
  const {
    t
  } = useTranslation();
  const {
    loading,
    transferTag,
    isTransferValid,
    resetTransferTag,
    vehicleHasDeposit
  } = useTransferTag();
  const {
    push
  } = useHistory();
  const onClick = async () => {
    const res = await transferTag();
    if (res) push(TRANSFER_TAG_SUMMARY);
  };
  useEffect(() => {
    return () => {
      resetTransferTag();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(TransferTagLayout, {
    hasForwardButtonDisabled: !isTransferValid,
    onForwardButtonClick: onClick,
    isForwardButtonLoading: loading,
    altForwardButtonText: t('buttons.transfer'),
    isFinalStep: true
  }, /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseTag, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseVehicle, null), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseAgreement, {
    transferTag: true
  }), vehicleHasDeposit && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(ChooseDeposit, null)));
}